import { pluck, map } from 'rxjs/operators'
import { ofType, ActionsObservable } from 'redux-observable'
import { syncType } from '../../../actions/sync/syncTypes'
import { fetchSyncDocuments } from '../../../actions/docs/docsActions'
import { SyncClient } from 'twilio-sync'
import { ReduxAction } from '../../../reducers/reducerType'

const fetchDocuments$ = (actions$: ActionsObservable<ReduxAction>) => actions$.pipe(
  ofType(syncType.SYNC_CLIENT_CONNECTED),
  pluck<ReduxAction<SyncClient>, SyncClient>('payload'),
  map((client: SyncClient) => fetchSyncDocuments(client))
)

export default fetchDocuments$
